import { Link } from 'react-router-dom'
const AffiliationCourse = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Affiliation & Course Study</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Academics</li>
                    <li>|</li>
                    <li>Affiliation & Course Study</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>This school (will) is permanently affiliated to the <span> Council for the Indian School Certificate Examinations,</span> New Delhi. The University of Cambridge Local Examinations Syndicate with the assistance of Inter state for Anglo-Indian Education established the Council for the Indian school Certificate Examinations in 1958 in 1973 the Govt. Of India recognized the council as body to conduct public Examinations in India through an Act of the Parliament and the councils appointed as one of the Indian Examination bodies. Indian Certificate of Secondary Education (ices) is recognized by all the education boards in the country and by many overseas too.</p>
                            <p>This is a Co-Educational school which prepares students for the <span>Indian Certificate of Secondary Education (ICSE)</span> New Delhi, from the Nursery classes up to 10th STD and every student is required to take the following subjects as course of study to class 10th: English (compulsory to get pass-mark for obtaining the pass certificate.)</p>
                            <ul className="list-view">
                                <li>Punjabi (compulsory till the 10th standard)</li>
                                <li>Hindi (being the National language of India, is compulsory up to 8th standard for all students.). those students who wish to get a pass certificate in Hindi subject should continue to take Hindi s ans optional language, also in the 9th and 10th std. Along with Punjabi which is compulsory for all up to 10th std. The school will make the necessary arrangements to engage a teacher, monitored by the Principal, to teach Hindi on request and on payment of an extra fee.</li>
                                <li>Mathematics</li>
                                <li>Science (physics, chemistry & Biology)</li>
                                <li>History, Civics, Geography</li>
                                <li>Environmental Studies</li>
                                <li>Physical Education/computer application. Socially use full productive Work & Community6 service</li>
                            </ul>
                            <p>ICSE pass certificate will be awarded to candidates who attain the pass mark for all subjects. However, it is compulsory to secure a pass grade in English & S.U.P.W.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AffiliationCourse
